<template lang="pug">
  //- Generic Modal
  div.modalgeneric
    ods-dialog(:visible.sync='dialogVisible' custom-class='alertDialog sc-modal' append-to-body)
      //- withTable
      div(v-if='modalType === "withTable"')
        Card(size='big').sc-dashboard__alert
          template(slot='header')
            div.modal-title {{ $t(modalTitle) }}
          div.maxSizeCard
            TableAndSearch(ref='search' @setDataVisualization="setDataVisualization"
          @hideDialogAlert="hideDialogAlert" :dataVisualizations="dataVisualizations")
      //- withTab
      div(v-if='modalType === "withTab"')
        //- Alertas
        template(v-if='modalTypeData === "alerts"')
          Card(size='big' v-if='!modalDetailShow' :loading='!loadAlertToday && !loadAlertWeek' :scrollbar='false').sc-dashboard__alert
            template(slot='header')
              div.modal-title {{ $t(modalTitle) }}
            div(v-if='loadAlertToday && loadAlertWeek')
              ods-tabs(v-model='alertsTab' @tab-click='handleTabs')
                ods-tab-pane(name='first')
                  div(slot='label' :alertsToday="alertsToday") {{ $t('today') }}
                    span.card-counter(v-if="alertsToday") {{ alertsToday.length }}
                    span.card-counter(v-else) 0
                  div.ods-tab--cero(v-if='alertsToday && !alertsToday.length')
                    StatusCero(
                      title='no data'
                      description='no data alerts today'
                    )
                  //- ods-scrollbar(v-else wrap-class='ods-scrollbar__wrap')
                  AlertsAndCampaignList(
                    v-else
                    height='calc(100% - 25px)'
                    alert
                    link
                    :dataTable='alertsToday'
                    @detailSelect='showAlertsDetail'
                  )
                ods-tab-pane(label='Últimos 7 días' name='second')
                  div(slot='label') {{ $t('last 7 days') }}
                    span.card-counter(v-if="alertsWeek") {{  alertsWeek.length }}
                    span.card-counter(v-else) 0
                  div.ods-tab--cero(v-if='alertsWeek && !alertsWeek.length')
                    StatusCero(
                      title='no data'
                      description='no data alerts week'
                    )
                  //- ods-scrollbar(v-else wrap-class='ods-scrollbar__wrap')
                  AlertsAndCampaignList(
                    v-else
                    height='calc(100% - 25px)'
                    alert
                    link
                    :dataTable='alertsWeek'
                    @detailSelect='showAlertsDetail'
                  )
          div.sc-modal__header__content(v-else)
            div.sc-modal__link
              ods-button(type='text' class='linked' @click="modalDetailShow = !modalDetailShow") {{ $t('volverlistadoalertas') }}
                ods-icon(name='arrow-left' size='18')
            div.sc-modal__title {{ alertsModalData.name }}
            div.sc-modal__header
              div.sc-modal__intro {{ $t('alerts') }} - {{ $t(alertsModalData.type) }}
              div.sc-modal__meta
                div.table-dot(v-if="alertsModalData.level === 'high'" class="table-dot--danger")
                div.table-dot(v-if="alertsModalData.level === 'medium'" class="table-dot--medium")
                div.table-dot(v-if="alertsModalData.level === 'low'" class="table-dot--warning")
                div.sc-modal__intro {{ $t('alert') }} {{ $t(alertsModalData.level) }}
            div.sc-modal__subtitle
            ods-scrollbar(wrap-class='ods-scrollbar__wrap')
              div.sc-modal__description {{ alertsModalData.description }}
            div.sc-modal__link
              ods-button(type='text' @click="showAlertMap(alertsModalData)") {{ $t('viewerInMap')}}
                ods-icon(name='arrow-right' size='18')
            div.sc-modal__body
              ods-row.sc-dashboard__row(type='flex' :gutter='16')
                ods-col(:span='5')
                  div.sc-modal__box
                    div.sc-modal__label {{ $t('hour') }}
                    div.sc-modal__data {{ formatLocaleHour(alertsModalData.date) }}
                ods-col(:span='6')
                  div.sc-modal__box
                    div.sc-modal__label {{ $t('date') }}
                    div.sc-modal__data {{ formatLocaleDate(alertsModalData.date) }}
                ods-col(:span='8')
                  div.sc-modal__box
                    div.sc-modal__label {{ $t('location') }}
                    div.sc-modal__data {{ alertsModalData.area }}
        //- Campañas
        template(v-if='modalTypeData === "campaigns"')
          Card(size='big' v-if='!modalDetailShow' :visible.sync='dialogCampaignVisible' :scrollbar='false' :loading='!!!campaignsActivesFiltered && !!!campaignsInactivesFiltered').sc-dashboard__campanigns
            template(slot='header')
              div.modal-title {{ $t(modalTitle) }}
            div(v-if='campaignShow')
              ods-tabs(v-model='campaignTab' @tab-click='handleTabs')
                ods-tab-pane(name='first')
                  div(slot='label') {{ $t('actives') }}
                    span.card-counter(v-if="campaignsActivesFiltered") {{campaignsActivesFiltered.length}}
                    span.card-counter(v-else) 0
                  template(v-if='campaignsActivesFiltered && !campaignsActivesFiltered.length')
                    StatusCero(
                      title='SIN DATOS'
                      description='No existen campañas activas. Intentelo de nuevo más tarde'
                    )
                  //- ods-scrollbar(v-else wrap-class='ods-scrollbar__wrap')
                  AlertsAndCampaignList(
                    v-else
                    height='calc(100% - 25px)'
                    link
                    campaign
                    :dataTable='campaignsActivesFiltered'
                    @detailSelect='showCampaignDetail'
                  )
                ods-tab-pane(label='Inactivas' name='second')
                  div(slot='label') {{ $t('inactives') }}
                    span.card-counter(v-if="campaignsInactivesFiltered") {{campaignsInactivesFiltered.length}}
                    span.card-counter(v-else) 0
                  template(v-if='campaignsInactivesFiltered && !campaignsInactivesFiltered.length')
                    StatusCero(
                      title='SIN DATOS'
                      description='No existen campañas inactivas. Intentelo de nuevo más tarde'
                    )
                  //- ods-scrollbar(v-else wrap-class='ods-scrollbar__wrap')
                  AlertsAndCampaignList(
                    v-else
                    height='calc(100% - 25px)'
                    link
                    campaign
                    :dataTable='campaignsInactivesFiltered'
                    @detailSelect='showCampaignDetail'
                  )
          //- template(v-else :visible.sync='campaignModal')
          div.sc-modal__header__content(v-else)
            div.sc-modal__link
              ods-button(type='text' class='linked' @click="modalDetailShow = !modalDetailShow") {{ $t('volverlistadocampanias') }}
                ods-icon(name='arrow-left' size='18')
            div.sc-modal__title {{ campaignsModalData.name }}
            div.sc-modal__header
              div.sc-modal__intro {{ $t('campaign') }} - {{ $t(campaignsModalData.type) }}
            ods-row.sc-dashboard__row(type='flex')
              div.sc-modal__meta
                ods-select.selectSocial(
                  v-model='levelCurrentFilter'
                  placeholder='Select'
                )
                  ods-option(
                    v-for='item in modalLevelFilters'
                    :key='item.value'
                    :label='$t(item.label)'
                    :value='item.value'
                  )
                ods-select.selectSocial(
                  v-model='stateCurrentFilter'
                  placeholder='Select'
                )
                  ods-option(
                    v-for='item in modalStateFilters'
                    :key='item.value'
                    :label='$t(item.label)'
                    :value='item.value'
                  )
                ods-button(type='secondary' size='small' round @click.native='updateStateLevelCampaign') {{ $t('Actualizar') }}
            div.sc-modal__subtitle
            ods-scrollbar(wrap-class='ods-scrollbar__wrap')
              div.sc-modal__description {{ campaignsModalData.description }}
            div.sc-modal__body
              ods-row.sc-dashboard__row(type='flex')
                ods-col(:span='8')
                  div.sc-modal__box
                    div.sc-modal__label {{ $t('startDate') }}
                    div.sc-modal__data {{ campaignsModalData.startDate }}
                ods-col(:span='8')
                  div.sc-modal__box
                    div.sc-modal__label {{ $t('endDate') }}
                    div.sc-modal__data {{ campaignsModalData.endDate }}
                ods-col(:span='8')
                  div.sc-modal__box
                    div.sc-modal__label {{ $t('location') }}
                    div.sc-modal__data La Aldea de San Nicolás
            div.sc-modal__procedure
              div.sc-modal__title {{ $t('Lanzar procedimiento según nivel') }}
              p {{ $t('Desde aqui puedes lanzar los procedimientos asociados al nivel de esta campaña sin tener que modificar su actual nivel.') }}
              ods-row.sc-dashboard__row(type='flex')
                div.sc-modal__meta
                  ods-select.selectSocial(
                    v-model='levelProcedureCurrentFilter'
                    placeholder='Select'
                  )
                    ods-option(
                      v-for='item in campaignsModalData.levelProcedure'
                      :key='item.order'
                      :label='$t(item.name)'
                      :value='item.name'
                    )
                  ods-button(type='secondary' size='small' round @click.native='updateLevelProcedureCampaign') {{ $t('Throw') }}
    //- Generic Modal

</template>

<script>

import Card from '@/components/Card'
import mapChartsElements from '@/mixins/mapChartsElements'
import AlertsAndCampaignList from '@/components/AlertsAndCampaignList'
import StatusCero from '@/components/StatusCero'
import TableAndSearch from '@/components/TableAndSearch'

export default {
  name: 'ModalGeneric',
  data () {
    return {
      alertsTab: 'first',
      dialogVisible: false,
      modalVisualization: false,
      modalDetailShow: false,
      alertsModalData: null,
      loadAlertToday: false,
      loadAlertWeek: false,
      campaignShow: true,
      campaignsModalData: null,
      dataVisualizations: [],
      campaignTab: 'first',
      dialogCampaignVisible: false,
      campaignsActives: undefined,
      campaignsActivesFiltered: undefined,
      campaignsInactives: undefined,
      campaignsInactivesFiltered: undefined,
      campaignCurrentFilter: ['1'],
      levelProcedureCurrentFilter: null,
      levelCurrentFilter: 0,
      stateCurrentFilter: 0,
      socialNetworkFilters: [{
        value: '1',
        label: 'All'
      }, {
        value: 'Twitter',
        label: 'Twitter'
      }, {
        value: 'Instagram',
        label: 'Instagram'
      }],
      modalLevelFilters: [{
        value: '0',
        label: 'Nivel 0'
      }, {
        value: '1',
        label: 'Nivel 1'
      }, {
        value: '2',
        label: 'Nivel 2'
      }, {
        value: '3',
        label: 'Nivel 3'
      }],
      modalStateFilters: [{
        value: 'activo',
        label: 'Activa'
      }, {
        value: 'inactivo',
        label: 'Inactiva'
      }],
      kpisFilters: [
        {
          value: 'all',
          label: 'All'
        },
        /* {
        value: '1',
        label: 'Emergencias y Seguridad'
        }, {
          value: '2',
          label: 'Iluminación y Ef. energética'
        }, {
          value: '3',
          label: 'Limpieza y Gestión de residuos'
        }, { */
        {
          value: 'parksAndGardens',
          label: 'Parques y Jardines'
        },
        {
          value: 'environment',
          label: 'Medioambiente y Meteorología'
        } /*, {
          value: '5',
          label: 'Movilidad y Transporte'
        }, {
        value: '6',
        label: 'Parques y Jardines'
        }, {
          value: '7',
          label: 'Vivienda y Urbanismo'
        } */
      ],
      alertsFilters: [
        {
          value: '1',
          label: 'All'
        }, /* {
          value: '1',
          label: 'Emergencias y Seguridad'
        }, {
          value: '2',
          label: 'Iluminación y Ef. energética'
        }, {
          value: '3',
          label: 'Limpieza y Gestión de residuos'
        }, { */
        {
          value: 'environment',
          label: 'Medioambiente y Meteorología'
        }, {
          value: 'mobility',
          label: 'Movilidad y Transporte'
        }, {
          value: 'parksAndGardens',
          label: 'Parques y Jardines'
        }/* , {
        value: '7',
        label: 'Vivienda y Urbanismo'
        } */],
      campaignFilters: [
        {
          value: '1',
          label: 'All'
        }, /* {
        value: '1',
        label: 'Emergencias y Seguridad'
        }, {
          value: '2',
          label: 'Iluminación y Ef. energética'
        }, {
          value: '3',
          label: 'Limpieza y Gestión de residuos'
        }, */
        {
          value: 'Environment',
          label: 'Medioambiente y Meteorología'
        },
        {
          value: 'Mobility',
          label: 'Movilidad y Transporte'
        },
        {
          value: 'parksandgardens',
          label: 'Parques y Jardines'
        }
        /*
        {
          value: '7',
          label: 'Vivienda y Urbanismo'
        }
        */
      ]
    }
  },
  props: {
    modalTitle: String,
    modalType: String,
    modalTypeData: String
  },
  mixins: [ mapChartsElements ],
  methods: {
    rerender (callback) {
      this.$nextTick(() => {
        callback()
      })
    },
    showDialogAlert () {
      this.dialogVisible = true
    },
    hideDialogAlert () {
      this.dialogVisible = false
    },
    changeAlertToday (data) {
      const component = this
      // this.loadAlertToday = true
      this.alertsToday = data
      component.loadAlertToday = false
      component.rerender(() => {
        component.loadAlertToday = true
      })
    },
    changeAlertWeek (data) {
      const component = this
      // this.loadAlertWeek = true
      this.alertsWeek = data
      component.loadAlertWeek = false
      component.rerender(() => {
        component.loadAlertWeek = true
      })
    },
    showAlertsDetail (data) {
      this.alertsModalData = data.list.find(item => {
        return item.id === data.selected.id
      })
      this.modalDetailShow = true
    },
    showAlertMap (data) {
      var list = [data]
      document.getElementById('dataIframe').contentWindow.showAlerts(list, 'medioambiente')
      // this.$emit('showAlertMap', list)
      this.dialogVisible = false
      this.modalDetailShow = false
    },
    handleTabs () {},
    setDataVisualization (data) {
      this.$emit('setDataVisualization', data)
    },
    showDialogCampaign () {
      this.dialogVisible = false
      this.dialogVisible = true
    },
    changeActiveCampaigns (data) {
      const component = this
      this.campaignsActivesFiltered = data
      component.campaignShow = false
      component.rerender(() => {
        component.campaignShow = true
      })
    },
    changeInactiveCampaigns (data) {
      const component = this
      this.campaignShow = true
      this.campaignsInactivesFiltered = data
      component.campaignShow = false
      component.rerender(() => {
        component.campaignShow = true
      })
    },
    showCampaignDetail (data) {
      this.campaignsModalData = data.list.find(item => {
        return item.id === data.selected.id
      })
      this.levelCurrentFilter = this.$t('Nivel ' + this.campaignsModalData.level)
      this.stateCurrentFilter = this.$t(this.campaignsModalData.state)
      this.modalDetailShow = true
      // this.campaignModal = true
    },
    updateStateLevelCampaign (value) {
      const component = this
      let inData = {
        id: component.campaignsModalData.id,
        level: component.levelCurrentFilter,
        state: component.stateCurrentFilter
      }
      component.$store.dispatch('updateLevelStateCampaign', inData).then(() => {
        component.modalDetailShow = true
        component.initCampaign()
        component.rerender(() => {
          component.modalDetailShow = false
        })
        component.$notify({
          title: 'Campaña actualizada',
          message: 'Se ha actualizado con éxito la campaña',
          type: 'success',
          customClass: ''
        })
      })
    },
    updateLevelProcedureCampaign (value) {
      let inData = {
        id: this.campaignsModalData.id,
        level: this.levelProcedureCurrentFilter
      }
      this.$store.dispatch('updateLevelProcedureCampaign', inData)
    },
    initCampaign () {
      let inData = {
        type: 'campaign',
        subtype: 'activo',
        numberItems: '20',
        page: '1'
      }
      this.$store.dispatch('updateAlertsCampaigns', inData)
      inData.subtype = 'inactivo'
      this.$store.dispatch('updateAlertsCampaigns', inData)
    },
    changeState (data) {
      let component = this
      this.modalVisualization = true
      // this.dialogVisible = true
      // this.modalTitle = this.modalTitle
      this.dataVisualizations = data
      component.dialogVisible = false
      component.rerender(() => {
        component.dialogVisible = true
      })
    }
  },
  created () {
    // this.initCampaign()
  },
  components: {
    Card,
    AlertsAndCampaignList,
    StatusCero,
    TableAndSearch
  }
}

</script>

<style lang="scss" scoped>

  /deep/ .ods-dialog.sc-modal {

    max-width: rem(750);

    .ods-dialog__body{
      margin-top: 0;
      padding: 0;
    }
    .sc-modal__body{
      align-items: center;
      background-color: $--color-white;
      display: flex;
      justify-content: center;
      margin-top: 0;
      width: 100%;
      .ods-row{
        width: 100%;
      }
    }
    .sc-card__body-inner{
      display: flex;
      height: rem(320);
      padding: 0;
    }

    /deep/ .ods-scrollbar__wrap{
      height: calc(100% - -17px);
      // max-height: inherit;
      .ods-scrollbar__view{
        height: 100%;
      }
    }

    .sc-modal__header {
      margin-bottom: rem(16);
    }
    .ods-select {
      margin-right: rem(24);
    }
    .sc-modal__procedure {
      margin-top: rem(32);
      padding-top: rem(16);
      width: 70%;
      .ods-input__inner {
        text-transform: capitalize;
      }
      p {
        margin-bottom: rem(24);
      }
      .sc-modal__title {
        font-size: rem(16);
        margin-bottom: rem(8);
      }
    }
  }

  /deep/ .alertDialog {

    .modal-title {
      color: $--color-grey-dark;
      font-size: rem(22);
      font-weight: 500;
      line-height: rem(40);
    }
    div[class^='table-dot']{
      margin-right: rem(8);
    }
    .linked{
      align-items: center;
      display: flex;
      margin-bottom: rem(24);
      i{
        &.ods-icon-arrow-left{
          float: left;
          margin: 0 6px 0 0;
        }
      }
    }
    .ods-tabs{
      height: 100%;
      &__content{
        height: 100%;
        width: 100%;
      }
      .ods-tab-pane, .ods-tab--cero  {
        height: 100%;
      }
    }
    .ods-dialog{
      &__body{
        max-height: auto;
        min-height: auto;
      }
    }
    .sc-card{
      .sc-card{
        &__body{
          min-height: auto;
          padding-top: rem(8);
          &-inner{
            & > div{
              width: 100%;
            }
          }
        }
        &__header{
          padding: 0;
          &__inner{
            border: 0;
          }
        }
      }
    }
    &.sc-modal{
      .sc-modal {
        &__header {
          margin-top: rem(16);
          &__content{
            padding: 0;
          }
        }
        &__link{
          margin: rem(8) 0 0;
        }
        &__body{
          background: $--color-primary-light-9;
          margin: rem(40) 0 0;
          width: auto;
          padding: rem(24);
        }
      }
    }
  }
  .maxSizeCard {
    height: 100%;
  }

  /deep/ .ods-scrollbar__bar {
    opacity: 1;
  }

</style>



// WEBPACK FOOTER //
// src/components/ModalGeneric.vue